import FormAutoCompleteLocation from '@components/forms/FormAutoCompleteLocation';
import FormInputDateTime from '@components/forms/FormInputDateTime';
import { Button, Divider, Stack, Typography } from '@mui/material';
import Grid from '@mui/material/Grid2';
import { useFormContext } from 'react-hook-form';
import { EventForm } from '@components/eventCreation/CreateEventUtils';
import { WeighInItem } from '@type/db-types';
import DeleteIcon from '@mui/icons-material/Delete';
import { EditOutlined } from '@mui/icons-material';
import { useState } from 'react';
import FormInputText from '@components/forms/FormInputText';

interface Props {
    editable?: boolean;
    item: WeighInItem;
    index: number;
}

export default function WeighInAtForm({
    editable = true,
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    item: _item,
    index,
}: Props) {
    const { setValue, watch } = useFormContext<EventForm>();
    const [startAt, weighInAt] = watch(['startAt', 'weighInAt']);
    const [editNote, setEditNote] = useState(!!weighInAt?.[index].note);

    return (
        <>
            <Divider sx={{ marginY: 2 }} />
            <Typography sx={{ paddingBottom: 2 }}>Weigh In Location #{index + 1}</Typography>
            <Grid container spacing={2} alignItems={'center'}>
                <Grid size={{ sm: 12, md: 5 }}>
                    <Stack flexDirection={editNote ? 'column' : 'row'}>
                        <FormInputDateTime
                            editable={editable}
                            dateTimePickerProps={{
                                maxDateTime: new Date(startAt),
                                // sx: { marginY: 4 },
                            }}
                            label="Weigh Ins Start Time"
                            name={`weighInAt[${index}].weighInAtDateTime`}
                        />
                        {editNote ? (
                            <FormInputText
                                editable={editable}
                                label="Note"
                                name={`weighInAt[${index}].note`}
                            />
                        ) : editable ? (
                            <Button
                                onClick={() => setEditNote(true)}
                                startIcon={<EditOutlined />}
                                sx={{ marginLeft: 1 }}
                            >
                                Note
                            </Button>
                        ) : null}
                    </Stack>
                </Grid>
                <Grid size={{ sm: 12, md: 5 }}>
                    <FormAutoCompleteLocation
                        editable={editable}
                        // @ts-expect-error - this deeply nested key should exist
                        name={`weighInAt[${index}].location`}
                        prefixFormLookup={`weighInAt[${index}].`}
                    />
                </Grid>
                {editable ? (
                    <Grid size={{ xs: 2 }}>
                        <Button
                            color="error"
                            onClick={() =>
                                setValue(
                                    'weighInAt',
                                    weighInAt?.filter((_, i) => i !== index) || null,
                                    {
                                        shouldDirty: true,
                                        shouldTouch: true,
                                        shouldValidate: true,
                                    },
                                )
                            }
                            startIcon={<DeleteIcon />}
                        >
                            Remove
                        </Button>
                    </Grid>
                ) : null}
            </Grid>
        </>
    );
}
